import React from 'react';
import { cn } from '@/lib/utils';

interface BackgroundPatternProps {
  className?: string;
  pattern?: 'dots' | 'grid' | 'waves' | 'villa';
  opacity?: number;
  color?: string;
}

export function BackgroundPattern({
  className,
  pattern = 'villa',
  opacity = 0.05,
  color = 'currentColor'
}: BackgroundPatternProps) {
  const patternStyles: React.CSSProperties = {
    opacity,
    color,
  };

  const renderPattern = () => {
    switch (pattern) {
      case 'dots':
        return (
          <svg
            width="100%"
            height="100%"
            xmlns="http://www.w3.org/2000/svg"
            className="absolute inset-0 pointer-events-none"
          >
            <defs>
              <pattern
                id="dots-pattern"
                x="0"
                y="0"
                width="20"
                height="20"
                patternUnits="userSpaceOnUse"
              >
                <circle cx="2" cy="2" r="1" fill="currentColor" />
              </pattern>
            </defs>
            <rect width="100%" height="100%" fill="url(#dots-pattern)" />
          </svg>
        );
      case 'grid':
        return (
          <svg
            width="100%"
            height="100%"
            xmlns="http://www.w3.org/2000/svg"
            className="absolute inset-0 pointer-events-none"
          >
            <defs>
              <pattern
                id="grid-pattern"
                x="0"
                y="0"
                width="20"
                height="20"
                patternUnits="userSpaceOnUse"
              >
                <path
                  d="M 20 0 L 0 0 0 20"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="0.5"
                />
              </pattern>
            </defs>
            <rect width="100%" height="100%" fill="url(#grid-pattern)" />
          </svg>
        );
      case 'waves':
        return (
          <svg
            width="100%"
            height="100%"
            xmlns="http://www.w3.org/2000/svg"
            className="absolute inset-0 pointer-events-none"
          >
            <defs>
              <pattern
                id="waves-pattern"
                x="0"
                y="0"
                width="100"
                height="20"
                patternUnits="userSpaceOnUse"
              >
                <path
                  d="M 0 10 Q 12.5 0, 25 10 Q 37.5 20, 50 10 Q 62.5 0, 75 10 Q 87.5 20, 100 10"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="0.5"
                />
              </pattern>
            </defs>
            <rect width="100%" height="100%" fill="url(#waves-pattern)" />
          </svg>
        );
      case 'villa':
      default:
        return (
          <svg
            width="100%"
            height="100%"
            xmlns="http://www.w3.org/2000/svg"
            className="absolute inset-0 pointer-events-none"
          >
            <defs>
              <pattern
                id="villa-pattern"
                x="0"
                y="0"
                width="60"
                height="60"
                patternUnits="userSpaceOnUse"
              >
                {/* Stylized house/villa roof */}
                <path
                  d="M 30 5 L 55 25 L 5 25 Z"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="0.5"
                />
                {/* House/villa base */}
                <rect x="10" y="25" width="40" height="25" 
                  fill="none" 
                  stroke="currentColor" 
                  strokeWidth="0.5" 
                />
                {/* Window */}
                <rect x="17" y="30" width="10" height="10" 
                  fill="none" 
                  stroke="currentColor" 
                  strokeWidth="0.5" 
                />
                {/* Window */}
                <rect x="33" y="30" width="10" height="10" 
                  fill="none" 
                  stroke="currentColor" 
                  strokeWidth="0.5" 
                />
                {/* Door */}
                <rect x="25" y="35" width="10" height="15" 
                  fill="none" 
                  stroke="currentColor" 
                  strokeWidth="0.5" 
                />
              </pattern>
            </defs>
            <rect width="100%" height="100%" fill="url(#villa-pattern)" />
          </svg>
        );
    }
  };

  return (
    <div
      className={cn('absolute inset-0 overflow-hidden', className)}
      style={patternStyles}
    >
      {renderPattern()}
    </div>
  );
} 